import {
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useGetOne } from "react-admin";
import CustomMessage from "../../unit/CustomMessage";
import CustomPaper from "../../unit/CustomPaper";
import CustomTable from "../../unit/CustomTable";
import CustomTableContainer from "../../unit/CustomTableContainer";
import formatCurrency from "../../unit/formatCurrency";
import formatDate from "../../unit/formatDate";
import formatPercentage from "../../unit/formatPercentage";
import useNotify from "../../unit/useNotify";

const TableCellRight = styled(TableCell)({ textAlign: "right" });

const LoanModificationPostoneLog = ({ ...props }) => {
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const appId = props.appId;
  const { data, error, isLoading, isPending, isFetching } = useGetOne(
    "loan/paymentschedule/modifyPostonePayment",
    { id: appId }
  );
  if (isPending || isFetching) {
    return <Typography sx={{ p: 5 }}>Loading...</Typography>;
  }
  if (error) return <CustomMessage message="Error loading Loan" />;
  if (!data) return <CustomMessage message="No data found for this id" />;
  const modifyPostponeData = data.modifyPostponeData;

  return (
    <>
      <CustomTableContainer component={CustomPaper}>
        <CustomTable stickyHeader id="table-loan-summary-modification-log-list">
          <TableHead>
            <TableRow>
              <TableCell sx={{ minWidth: "120px" }} className="hm-table-header">
                Reset Date
              </TableCell>
              <TableCell sx={{ minWidth: "120px" }} className="hm-table-header">
                Reset by
              </TableCell>
              <TableCell sx={{ minWidth: "120px" }} className="hm-table-header">
                Original Payment Date
              </TableCell>
              <TableCell sx={{ minWidth: "120px" }} className="hm-table-header">
                New Payment Date
              </TableCell>
              <TableCell sx={{ minWidth: "120px" }} className="hm-table-header">
                Payment Amount
              </TableCell>
              <TableCell sx={{ minWidth: "120px" }} className="hm-table-header">
                Remaining Payments
              </TableCell>
              <TableCell sx={{ minWidth: "120px" }} className="hm-table-header">
                New Maturity Date
              </TableCell>
              <TableCell className="hm-table-header">Notes</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {modifyPostponeData &&
              modifyPostponeData.map((item: any) => (
                <TableRow key={item.iId}>
                  <TableCell className="dateText">
                    {formatDate(item.created_at)}
                  </TableCell>
                  <TableCell className="dateText">{item.created_by}</TableCell>
                  <TableCell className="dateText">
                    {formatDate(item.dOriginalDate)}
                  </TableCell>
                  <TableCell className="dateText">
                    {formatDate(item.dUpdateDate)}
                  </TableCell>
                  <TableCell className="numericText">
                    {formatCurrency(item.dFirstPaymentAmount)}
                  </TableCell>
                  <TableCell className="numericText">
                    {item.iRemainingTerms}
                  </TableCell>
                  <TableCell className="dateText">
                    {formatDate(item.dNewMaturityDate)}
                  </TableCell>
                  <TableCell>{item?.sComment}</TableCell>
                </TableRow>
              ))}
          </TableBody>
        </CustomTable>
      </CustomTableContainer>
    </>
  );
};

export default LoanModificationPostoneLog;
